import elementBase from "./elementBase.js";
import vueStore from "../../config.js";
import * as namespaceStore from "../../namespaceStore.js"
import creator from "./creator.js"
import containerItem from "../item/container.js"
import { reactive } from 'vue'

export default class Grid extends elementBase {
    objectType = "GridElement";
    styleColor = "#5000007d";
    _X = 1;
    _Y = 1;
    Gap = 10;
    _Contents = [] //list class element

    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }
    objectToClassValue(args = {}) {
        let contents = [];
        args = this.constructor.fromObjectToObject(args);
        if (args.contents && args.id != "COMPOSITION_SELECTION_GRID") {
            for (const el of args.contents) {
                contents.push(creator(el.objectType, el));
            }
            args.contents = contents;
        }
        super.objectToClassValue(args);
        if (this.id == "COMPOSITION_SELECTION_GRID") {
            if (args.contents == undefined || args.contents.length == 0) {
                const composition = vueStore.getters[namespaceStore.THEME + "/compositions"];
                this._Contents = composition && composition.length > 0 ? composition.map(el => el.previewId) : [];
            }
            else {
                this._Contents = args.contents.filter(el => typeof el == "string");
            }
            document.addEventListener("composition-set", this.setCompositionContents.bind(this));
            document.addEventListener("composition-add", this.addCompositionContents.bind(this));
            document.addEventListener("composition-remove", this.removeCompositionContents.bind(this));
        }
        else {
            this._Contents = args.contents ? args.contents : [];
            this._Contents.forEach((d) => { d.parent = this });
        }
        this.Gap = args.gap != null ? args.gap : 10;
        if (!args.x && !args.y) {
            const factor = this.findFactor(this.Contents.length, 1, 1);
            this._X = factor[0];
            this._Y = factor[1];
        }
        else {
            this._X = args.x != null ? args.x : 1;
            this._Y = args.y != null ? args.y : 1;
        }
    }

    findFactor(length, actualX, actualY) {
        let factor = [0, 0];
        let minDistanceX = -1;
        let minDistanceY = -1;
        for (let i = 1; i <= Math.sqrt(length); i++) {
            if (length % i == 0) {
                const f = length / i;
                if (minDistanceX == -1 || (Math.abs(f - actualX) + Math.abs(i - actualY)) < minDistanceX + minDistanceY) {
                    minDistanceX = Math.abs(f - actualX);
                    minDistanceY = Math.abs(i - actualY);
                    factor = [f, i];
                }
            }
        }
        return factor;
    }

    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "X", construct: Number, jsType: "Number" },
            { property: "Y", construct: Number, jsType: "Number" },
            { property: "Gap", construct: Number, jsType: "Number" },
            { property: "Contents", construct: containerItem, jsType: "Array" },
        ];
    }

    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name: "X", text: "Nombre de colonnes", type: "numberInput", dataType: "number" },
            { name: "Y", text: "Nombre de lignes", type: "numberInput", dataType: "number" },
            { name: "Gap", text: "Espacement entre les éléments", type: "numberInput", dataType: "number" },
            { name: "Contents", text: "Contenu de la grille", type: "arrayInput", dataType: "object", elementOption: "pageElement", options: elementBase, elements: { name: "Contents", type: "objectInput", dataType: "object", options: elementBase } },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }

    addCompositionContents() {
        const composition = vueStore.getters[namespaceStore.THEME + "/compositions"];
        composition.forEach(el => {
            if (this._Contents.find(c => c == el.previewId) == undefined) {
                this._Contents.push(el.previewId);
            }
        });
        if (this.Contents.length > 0 && this._X * this._Y < this.Contents.length) {
            const factor = this.findFactor(this.Contents.length, this._X, this._Y);
            this._X = factor[0];
            this._Y = factor[1];
        }
    }

    removeCompositionContents() {
        const composition = vueStore.getters[namespaceStore.THEME + "/compositions"];
        this._Contents.forEach((el, index) => {
            if (composition.find(c => c.previewId == el) == undefined) {
                this._Contents.splice(index, 1);
            }
        });
        if (this.Contents.length > 0 && this._X * this._Y < this.Contents.length) {
            const factor = this.findFactor(this.Contents.length, this._X, this._Y);
            this._X = factor[0];
            this._Y = factor[1];
        }
    }

    setCompositionContents() {
        this.removeCompositionContents();
        this.addCompositionContents();
    }

    swapArrayElement(index, move) {
        if (index < 0 && index > this._Contents.length) return;
        this._Contents.splice(index + move, 0, this._Contents.splice(index, 1)[0]);
    }
    exportedContents(minify = false) {
        if (this._Contents.length == 0) return [];
        if (this.id == "COMPOSITION_SELECTION_GRID") {
            return this._Contents;
        }
        return this.Contents.map(el => el.toObject(minify));
    }
    get Contents() {
        if (this.id == "COMPOSITION_SELECTION_GRID") {
            const composition = vueStore.getters[namespaceStore.THEME + "/compositions"];
            return this._Contents.map(c => {
                const finded = composition.find(el => el.previewId == c);
                if (finded) {
                    finded.Thumbnail.parent = this;
                    return finded.Thumbnail;
                }
                return null;
            }).filter(el => el != null);
        }
        return this._Contents;
    }
    set Contents(value) {
        this._Contents = reactive(value);
    }
    static get Name() {
        return "Grid";
    }
    get X() {
        return this._X;
    }
    set X(value) {
        if (value <= 0)
            value = 1;
        if (value * this._Y < this.Contents.length)
            this._Y = Math.ceil(this.Contents.length / value);
        this._X = value;
    }
    get Y() {
        return this._Y;
    }
    set Y(value) {
        if (value <= 0)
            value = 1;
        if (value * this._X < this.Contents.length)
            this._X = Math.ceil(this.Contents.length / value);
        this._Y = value;
    }
    getStyle(currentElementIndex = null) {
        let style = {
            ...super.getStyle(currentElementIndex),
            display: "grid",
            gridTemplateColumns: Array.from({ length: this.X }, () => "auto").join(" "),
            gridTemplateRows: Array.from({ length: this.Y }, () => "auto").join(" "),
            gridGap: this.Gap + "px",
            justifyContent: "unset",
            alignItems: "unset",
            position: "absolute",
        }
        return style;
    }
    static fromObject(object = {}) {
        return new this.prototype.constructor(object);
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            contents: this.Contents.length > 0 ? this.Contents.map(el => el.toExportObject(variableArray, ressourceArray)) : [],
            x: this.X,
            y: this.Y,
            gap: this.Gap,
        };
    }
    toObject(minify = false) {
        return {
            ...super.toObject(minify),
            contents: this.exportedContents(minify),
            x: this.X,
            y: this.Y,
            gap: this.Gap,
        }
    }
}
